module.exports = __webpack_public_path__ + "static/img/033_TO8_1515_og.183464b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/033_TO8_1515_og.jpg
// module id = AS6O
// module chunks = 0